import "./ShowPolicy.css";

import { Breadcrumb, Button, message } from "antd";
import { BiEdit } from "react-icons/bi";
import { BsTrash } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { deletePolicy, useAppSelector } from "../../../_lib/_store";

export const ShowPolicyPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading } = useAppSelector((state) => state.policy);

  const navigate = useNavigate();
  const { state } = useLocation();

  const policyObj = state?.policy;

  const handleDelete = async () => {
    const res = await deletePolicy(messageApi, policyObj?.id);
    if (res) {
      navigate("/policy");
    }
  };

  return (
    <>
      {contextHolder}
      <div className="createCategory">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: <Link to="/policy">Policy</Link>,
            },
            {
              title: "Show",
            },
          ]}
        />

        <div className="titleHeader">
          <h2 className="title">Show</h2>
          <div className="actionButton">
            <Button
              icon={<BiEdit />}
              size="large"
              onClick={() =>
                navigate(`/policy/edit`, {
                  state: { policy: state?.policy },
                })
              }
            >
              Edit
            </Button>
            <Button
              icon={<BsTrash />}
              size="large"
              onClick={handleDelete}
              loading={isLoading}
            >
              Delete
            </Button>
          </div>
        </div>

        <div className="form">
          <div className="row">
            <p className="label">Title</p>
            <p className="value">{policyObj?.title}</p>
          </div>
          <div className="row">
            <p className="label">Id</p>
            <p className="value">{policyObj?.id}</p>
          </div>
          <div className="row">
            <p className="label">Package Id</p>
            <p className="value">{policyObj?.package?.name}</p>
          </div>
          <div className="row">
            <p className="label">Category Id</p>
            <p className="value">{policyObj?.category?.name}</p>
          </div>
          <div className="row">
            <p className="label">Sub Category Id</p>
            <p className="value">{policyObj?.subCategory?.name}</p>
          </div>
          <div className="row">
            <p className="label">Content</p>
            <div
              dangerouslySetInnerHTML={{ __html: policyObj?.content || "" }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
